import { createFileRoute } from "@tanstack/react-router";
import { m } from "#/paraglide/messages";
import { useGetParcelDetail } from "#/lib/api/parcel";
import { useTenant } from "#/contexts/TenantContext";
import { hasPermission, ACTION_PERMISSIONS } from "#/utils/permissions";
import { ParcelShowPage } from "#/components/pages/parcels/parcel-show-page";
import type { ParcelDetailRow } from "#/components/organisms/parcel/types";

export const Route = createFileRoute("/$tenantCode/$market/parcels_/$parcelId")(
  {
    beforeLoad: () => ({
      getTitle: () => m["resources.parcel.show.title"](),
    }),
    component: ParcelShowRoute,
  },
);

function ParcelShowRoute() {
  const { parcelId } = Route.useParams();
  const { permissions, isAdmin } = useTenant();

  const { data, isLoading } = useGetParcelDetail(parcelId);

  const canViewCost = hasPermission(
    permissions,
    isAdmin,
    ACTION_PERMISSIONS["parcel-view-cost"],
  );

  return (
    <ParcelShowPage
      parcel={data as ParcelDetailRow | undefined}
      isLoading={isLoading}
      parcelId={parcelId}
      canViewCost={canViewCost}
    />
  );
}
